import { FC } from 'react';
import { FormControl } from 'react-bootstrap';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import classlist from 'utils/classlist';
import patterns from 'utils/patterns';
import styles from './style.scss';

export interface PhoneProps extends FormGroupProps {
    name?: string;
    disabled?: boolean;
    onChange?(value?: string | object): void;
    className?: string;
}

const $validators = {
    isError: () => true
};

const Phone: FC<PhoneProps> = ({ name = 'phone', disabled, onChange, className, ...restProps }) => {
    return (
        <FormGroup
            className={classlist(styles.root, className)}
            name={name}
            $validators={$validators}
            $onFieldChange={onChange}
            isError
            checker={value => {
                if (disabled) {
                    return true;
                }

                if (!value) {
                    return __('Please enter your phone number');
                }

                if (!patterns.isPhone(value)) {
                    return __('Please enter a valid phone number');
                }

                return true;
            }}
            {...restProps}>
            <FormControl placeholder={__('Phone Number')} disabled={disabled} />
        </FormGroup>
    );
};

export default Phone;
